/**
 * Modal의 샘플용 화면
 */

export default {
  computed: {
  }, // end computed
  methods: {
    /**
     * 'Modal1 보이기' 버튼 이벤트 처리
     */
    onClickModal1Button () {
      this.isVisibleModal1 = true
    },
    /**
     * 'Modal2 보이기' 버튼 이벤트 처리
     */
    onClickModal2Button () {
      this.isVisibleModal2 = true
    },

    onClickModal2Confirm () {
      this.$buefy.toast.open({
        message: '확인 버튼이 클릭되었습니다.',
        type: 'is-info',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    },

    onClickModal2Close () {
      this.$buefy.toast.open({
        message: '닫기 버튼이 클릭되었습니다.',
        type: 'is-info',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    },

    onClickModal2Cancel () {
      this.$buefy.toast.open({
        message: '취소 버튼이 클릭되었습니다.',
        type: 'is-info',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    },

    onClickCustomButton () {
      this.$buefy.toast.open({
        message: 'Custom Button이 클릭되었습니다.',
        type: 'is-info',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    }

  }, // end methods
  data () {
    return {
      isVisibleModal1: false, // Modal1의 보이기 여부
      isVisibleModal2: false // Modal2의 보이기 여부
    }
  }
}
